import { useEffect, useState, type MouseEvent } from 'react';

export interface TocItem {
  id: string;
  label: string;
  index: string;
}

export default function ContentNav({ items }: { items: TocItem[] }) {
  const [active, setActive] = useState(items[0]?.id ?? '');

  useEffect(() => {
    const onScroll = () => {
      let current = items[0]?.id ?? '';
      items.forEach((item) => {
        const el = document.getElementById(item.id);
        if (el && el.getBoundingClientRect().top <= 160) current = item.id;
      });
      setActive(current);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [items]);

  const handleClick = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav
      aria-label="本页目录"
      className="rounded-lg border border-background-200 bg-background-100 overflow-hidden"
    >
      <div className="px-4 py-3 border-b border-background-200 flex items-center gap-2">
        <i className="ri-list-unordered text-primary-600"></i>
        <h2 className="font-heading text-sm font-bold text-foreground-950">本页目录</h2>
      </div>
      <ul className="p-2">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              onClick={(e) => handleClick(e, item.id)}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                active === item.id
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-600 hover:bg-background-200/50 hover:text-foreground-900'
              }`}
            >
              <span className="font-label text-[11px] text-foreground-400 w-5">{item.index}</span>
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}